<div class="dialog-container" data-testid="moh-warning-ack-dialog">
  <div class="dialog-header">
    <h1 class="dialog-title">Acknowledge material warning</h1>
    <button mat-icon-button (click)="onDismiss()" data-testid="moh-warning-ack-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-message">
    @if (data.itemCode) {
      <div class="item-code">{{ data.itemCode }}</div>
    }
    <p>{{ data.message }}</p>
  </div>

  <mat-form-field appearance="outline" class="comment-field">
    <mat-label>Acknowledgement comment</mat-label>
    <textarea
      matInput
      rows="4"
      [formControl]="comment"
      data-testid="moh-warning-ack-comment"
    ></textarea>
    @if (comment.hasError('required') && comment.touched) {
      <mat-error>Comment is required.</mat-error>
    }
  </mat-form-field>

  <div class="mat-dialog-actions">
    <button mat-stroked-button color="primary" (click)="onDismiss()" data-testid="moh-warning-ack-cancel">Cancel</button>
    <button mat-flat-button color="primary" (click)="onConfirm()" data-testid="moh-warning-ack-confirm">Acknowledge</button>
  </div>
</div>
